export default "__VITE_ASSET__rLXNAtYn__"